const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Question Builder Component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('fileQuestionBuilder', ['Application', 'AssessmentLib', '$translate', function (Application, AssessmentLib, $translate) {
  return {
    restrict: 'E',
    scope: {
      question: '=',
      newAssessment: '=',
      save: '&'
    },
    template: require('../../../templates/directives/assessments/file-question-builder.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};

      self.info = {
        setOption: function(type, value) {
          if (!$scope.question) {
            return null;
          }
          if (!$scope.question.question_options) {
            $scope.question.question_options = [];
          }
          for (var i = 0; i < $scope.question.question_options.length; i++) {
            if ($scope.question.question_options[i] && $scope.question.question_options[i].name === type) {
              $scope.question.question_options[i].value = value;
              return;
            }
          }
          $scope.question.question_options.push({name: type, value: value});
        },
        getOption: function(type) {
          if (!$scope.question) {
            return null;
          }
          if (!$scope.question.question_options) {
            $scope.question.question_options = [];
            return null;
          }
          for (var i = 0; i < $scope.question.question_options.length; i++) {
            if ($scope.question.question_options[i] && $scope.question.question_options[i].name === type) {
              return $scope.question.question_options[i].value;
            }
          }
        },
        manualPoints: 1,
        manualPointsChange: function(add) {
          if (add) {
            self.info.manualPoints++;
          }
          if (!add && self.info.manualPoints > 1) {
            self.info.manualPoints--;
          }
          self.info.manualPointsUpdate();
        },
        manualPointsUpdate: function() {
          if (self.info.manualPoints) {
            self.info.setOption('manual_points', self.info.manualPoints);
          }
        },
        save: function() {
          if ($scope.newAssessment) {
            return;
          }
          if (!$scope.question.question) {
            // error for prompt
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.add_prompt']});
            return;
          }
          if (!self.info.getOption('upload_type')) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add at least one accepted format for the file.'});
            return;
          }
          if (!$scope.question.rubric_grading && !self.info.getOption('manual_points')) {
            // error for points for non rubric
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.video_points']});
            return;
          }
          if ($scope.question.rubric_grading) {
            if (!$scope.question.question_options || !$scope.question.question_options.length) {
              // error for points for non rubric
              Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.video_points']});
              return;
            }

            for (var i = 0; i < $scope.question.rubric_options.length; i++) {
              var item = $scope.question.rubric_options[i];
              if (!item) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.empty_rubric']});
                return;
              }
              if (!item.name || !item.points || !item.description) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.assessment.rubric_requirements']});
                return;
              }
            }
          }

          self.info.setUploadType();
          $scope.save();
        },
        options: ['pdf', 'xls', 'jpeg', 'png', 'doc'],
        setUploadType: function(type) {
          var list = [];
          self.info.options.forEach(function(opt) {
            if (self.info[opt]) {
              list.push(opt);
            }
          });
          self.info.setOption('upload_type', list.join(','));
        },
        setInitial: function() {
          var current = self.info.getOption('upload_type') || '';
          current = current.split(',');
          current.forEach(function(item) {
            if (self.info.options.indexOf(item) !== -1) {
              self.info[item] = true;
            }
          });
        },
        totalPoints: function() {
          return AssessmentLib.helpers.getQuestionValue($scope.question);
        }
      };

      self.info.options.forEach(function(opt) {
        self.info[opt] = false;
      });

      $scope.$watch('videoBuilder.info.recordingLimit', function(newVal, oldVal) {
        if (newVal || newVal === 0) {
          if (newVal < 1) {
            self.info.recordingLimit = 1;
            self.info.recordingLimitUpdate();
            return;
          }
          if (newVal > 60) {
            self.info.recordingLimit = 60;
            self.info.recordingLimitUpdate();
            return;
          }
          self.info.recordingLimitUpdate();
        }
      });

      $translate([
        'edit.assessment.add_prompt',
        'edit.assessment.video_set_type',
        'edit.assessment.video_points',
        'edit.assessment.empty_rubric',
        'edit.assessment.rubric_requirements',
      ]).then(function(translations) {
        self.translations = translations;
      });


      if ($scope.question) {
        self.info.manualPoints = self.info.getOption('manual_points') || 1;
        self.info.setInitial();
        return;
      }

      var questionWatch = $scope.$watch('question', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.info.manual_points = self.info.getOption('manual_points') || 1;
          self.info.setInitial();
          questionWatch();
        }
      });

    }],
    controllerAs: 'fileBuilder'
  };
}]);